<template>
    <main>
        <h1>Jeux de "Catégorie"</h1>
        <p class="gamesNumber">Découvres-y 0 jeux !</p>
        
        <section>
            <div class="all-games">
                <div class="jeu-container" v-for="i in 24" :key="i">
                    <div class="jeu">
                        <a>
                            <div class="img"></div>
                            <div class="contenu">
                                <p>Titre du jeu</p>
                                <span>Joué 0 fois</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    export default {
        name: 'SkeletonCategorie'
    }
</script>

<style scoped src="@/assets/categorie.css">
</style>
<style scoped src="@/assets/skeletonCategorie.css">
</style>